const { h, render, Component } = require('preact');
const {route} = require('preact-router');

const LoggedInOtherIssuesView = require('../../views/main/logged_in_other_issues');
const BreadCrumbsHelper = require('../../views/common/breadcrumbs/helper')

class LoggedInOtherIssues extends Component {
  constructor(props) {
    super(props);
    this.handleFacebookOrderHelp = this.handleFacebookOrderHelp.bind(this);
  }

  handleFacebookOrderHelp() {
    route(`/faq#faqs:${Groupon.Utils.getConfigFromDom().fbOrderContactLandingFAQId}?crumbs=${BreadCrumbsHelper.articleCrumbQSWithoutFAQs()}`);
  }

  render() {
    return (
      <LoggedInOtherIssuesView handleFacebookOrderHelp={this.handleFacebookOrderHelp} />
    );
  }
}
module.exports = LoggedInOtherIssues
